<template>
    <div class="bax-collapsible" v-bind:class="color === 'dark' ? 'bax-collapsible-dark' : ''">
        <div class="bax-collapse">
            <div
                class="bax-collapse-header d-md-flex"
                v-bind:class="openAllButton || (open === true) ? 'bax-collapse-active' : ''"
                @click="toggle"
            >
                <h3>{{ title }}</h3>
                <h4 v-if="label">{{ label }}</h4>
                <span class="d-flex align-items-center ml-auto" v-if="!openAllButton">
                    {{ open === true ? 'Show less' : 'Show more' }}
                    <i
                            class="d-flex justify-content-center align-items-center"
                            v-bind:class="[open === true ? 'icon-chevron-down' : 'icon-chevron-up']"
                    >
                    </i>
                </span>
                <span class="d-flex align-items-center ml-auto" v-if="openAllButton">
                    {{ open === true ? 'Hide all details' : 'Show all details' }}
                    <i
                            class="d-flex justify-content-center align-items-center"
                            v-bind:class="[open === true ? 'icon-chevron-down' : 'icon-chevron-up']"
                    >
                    </i>
                </span>
            </div>

            <div class="bax-collapse-content" v-if="openAllButton || (open === true)">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VueAccordian',
    props: {
        title: {
            type: String,
        },
        label: {
            type: String,
        },
        color: {
            type: String,
            default: '',
        },
        defaultOpen: {
            type: Boolean,
        },
        openAllButton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            open: false,
        };
    },
    created() {
        if (this.defaultOpen === true) {
            this.open = true;
        }
    },
    methods: {
        toggle() {
            if (this.open === false) {
                this.open = true;
                if (this.openAllButton) {
                    this.$emit('open-details');
                }
            } else {
                this.open = false;
                if (this.openAllButton) {
                    this.$emit('close-details');
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">
button {
    background: none;
    padding: 0;
}
</style>
